module.exports = __webpack_public_path__ + "img/businesscredit.19d9a78.png";